import { useMutation } from 'react-query';

import { getUserExtDomain as mutationFn } from 'api/endPoints/getUserExtDomain';

export const useMutationGetUserDomain = () => {
    return useMutation<QueryResponse, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    username: string;
}

interface QueryResponse {
    domain: string;
}
